import { sendCAPIEvent } from "@/lib/meta-capi";

import type { LeadConversionAdapter } from "../contracts";
import { createDeliveryResult } from "../contracts";

export const metaCapiLeadAdapter: LeadConversionAdapter = {
  id: "meta-capi",
  async trackLead(event, matchData) {
    if (event.consent.advertising === "denied") {
      return createDeliveryResult({
        provider: this.id,
        channel: "server",
        eventName: "Lead",
        status: "skipped",
        eventId: event.conversionEventId,
        reason: "advertising_consent_denied",
      });
    }

    const result = await sendCAPIEvent({
      event_name: "Lead",
      event_id: event.conversionEventId,
      event_source_url: event.sourceUrl,
      user_data: {
        em: matchData?.email,
        ph: matchData?.phone,
        fn: matchData?.firstName,
        ln: matchData?.lastName,
      },
      custom_data: { content_name: "consultation_request" },
    });

    return createDeliveryResult({
      provider: this.id,
      channel: "server",
      eventName: "Lead",
      status: result.ok ? "sent" : "failed",
      eventId: event.conversionEventId,
      reason: result.ok ? undefined : result.reason,
    });
  },
};
